<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section">
<h1>1</h1>
<p>I seem to have lost all my senses. By which I don’t mean that I’ve gone mad, although I might have. I simply can’t see anything, can’t hear or smell anything and don’t seem to be capable of communication; not that there seems to be anyone to communicate with.</p>
<p>I don’t even know if I’m dead or alive; although, I’m obviously able to think. It’s a condition I’ve never experienced before so I have no way of knowing where or what I am. But if this is how things are now, I’m really scared, even panic-stricken, because it’s not an existence anyone would want.</p>
<p>But gradually, things seem to change. Imperceptibly from total blackness to a dark grey. Faint sounds, hums and whirs, the noise of machinery and the sound of voices, talking quietly in the distance. And the smell of disinfectant and something else I can’t place.</p>
<p>The darkness clears more and there’s light. I can see an overhead light. I’m in a bed with tubes and wires connecting me to machines and displays. I’m in a hospital bed, in a room where there’s only me. And I can’t move, apart from weak changes to the position of my head and arms.</p>
<p>Then I’m no longer alone. I become conscious of a voice nagging inside my head, telling me it’s all my fault. I’ve caused a lot of damage and I’m to blame for everything.</p>
<p>“For what?” I’m still confused, not fully awake. I’m talking aloud to an internal voice. “I don’t know what you mean.”</p>
<p>But the voice keeps repeating that it’s my fault, that I’m to blame. Do I remember what happened? That I wouldn’t let go. That I wouldn’t listen to anything I was told, wouldn’t take advice. All because of that woman. Do I remember that woman?</p>
<p>And after a while, it starts to come back to me. I do remember that woman. I do remember her…</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?a7fbf2da